import {call, put, takeLatest} from 'redux-saga/effects';
import {
  // get chat messages
  getChatMessagesRequest,
  getChatMessagesSuccess,
  getChatMessagesFailure,

  // send chat message
  sendChatMessageRequest,
  sendChatMessageSuccess,
  sendChatMessageFailure,

  // schedule meet
  scheduleMeetRequest,
  scheduleMeetSuccess,
  scheduleMeetFailure,
} from '../slices/chatSlice';

import {getChatMessages, sendChatMessage, scheduleMeet} from '@/services/api';
import {SUCCESS_KEY} from '@/constants';

function* GetChatMessagesSaga(action: any): Generator {
  try {
    const response: any = yield call(getChatMessages, action.payload);
    const {id: consultation_id} = action.payload;
    if (response.data.status === SUCCESS_KEY) {
      yield put(getChatMessagesSuccess(response.data));
    } else {
      yield put(getChatMessagesFailure({...response.data, data: {consultation_id}}));
    }
  } catch (error: any) {
    yield put(getChatMessagesFailure(error.response));
  }
}

function* SendChatMessageSaga(action: any): Generator {
  try {
    const response: any = yield call(sendChatMessage, action.payload);
    const {id: consultation_id} = action.payload;
    if (response.data.status === SUCCESS_KEY) {
      yield put(sendChatMessageSuccess(response.data));
    } else {
      yield put(sendChatMessageFailure({...response.data, data: {consultation_id}}));
    }
  } catch (error: any) {
    yield put(sendChatMessageFailure(error.response));
  }
}

function* ScheduleMeetSaga(action: any): Generator {
  try {
    const { id, meet_time, provider, onSuccess, onError } = action.payload;
    const response: any = yield call(scheduleMeet, { id, meet_time, provider });
    if (response.data.status === SUCCESS_KEY) {
      yield put(scheduleMeetSuccess(response.data));
      yield put(getChatMessagesRequest({id}));
      if (onSuccess) onSuccess();
    } else {
      yield put(scheduleMeetFailure(response.data));
      if (onError) onError();
    }
  } catch (error: any) {
    yield put(scheduleMeetFailure(error.response));
    if (action.payload.onError) action.payload.onError();
  }
}

export default function* ChatSaga(): Generator {
  yield takeLatest(getChatMessagesRequest.type, GetChatMessagesSaga);
  yield takeLatest(sendChatMessageRequest.type, SendChatMessageSaga);
  yield takeLatest(scheduleMeetRequest.type, ScheduleMeetSaga);
}
